import { put, select, takeEvery } from "redux-saga/effects";
import { locationSetIntent } from "../hotspotEditor/hotspotEditorReducers";
import { getKeyFrameCount } from "../selectors";
import { showSpinHint } from "../ui/ui";

export function* locationSetIntentWorker() {
  const kfCount = yield select(getKeyFrameCount);
  if (kfCount === 1 || kfCount === 2) {
    yield put(showSpinHint());
  }
}

export function* locationSetIntentWatcher() {
  yield takeEvery(locationSetIntent().type, locationSetIntentWorker);
}
